export default {
    productTypes: { list: [], view: {}, new: {}, edit: { id: -1, name: '' } }
};
